import {
    getRawCssVariable as getRaw,
    RawColor,
    token,
} from '@minds/minds-react-sdk';
import styles from '../styles/colors.module.scss';
import { toCamelCaseObject } from './transformations';

export const color = token;
export const getRawCssColor = getRaw;

interface StyleGuideColors {
    primary: RawColor;
    primaryLight: RawColor;
    primaryLight2: RawColor;
    primaryLight3: RawColor;
    primaryLight4: RawColor;
    primaryLight5: RawColor;
    primaryAccent: RawColor;
    secondary: RawColor;
    secondaryBright: RawColor;
    secondaryLight: RawColor;
    secondaryLight2: RawColor;
    secondaryLight3: RawColor;
    secondaryLight4: RawColor;
    secondaryLight5: RawColor;
    secondaryLight6: RawColor;
    secondaryLight7: RawColor;
    secondaryLight8: RawColor;
    secondaryLight9: RawColor;
    tertiary: RawColor;
    tertiaryLight: RawColor;
    defaultGray: RawColor;
    darkGray: RawColor;
    gray: RawColor;
    red: RawColor;
    errorRed: RawColor;
    bluePrimary: RawColor;
    grayLight: RawColor;
    grayLight1: RawColor;
    grayLight2: RawColor;
    grayLight3: RawColor;
    grayLight4: RawColor;
    grayLight5: RawColor;
    grayLight6: RawColor;
    lightGray: RawColor;
    lightRed1: RawColor;
    lightRed2: RawColor;
    lightRed3: RawColor;
    lightRed4: RawColor;
    lightRed5: RawColor;
    lightRed6: RawColor;
    dangerRed: RawColor;
    lightGreen: RawColor;
    irishGreen: RawColor;
    darkGreen: RawColor;
    dangerYellow: RawColor;
}

export const COLORS = toCamelCaseObject(styles) as unknown as StyleGuideColors;

export const BREAKPOINTS = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};

export const SILENCED_CATEGORIES_CACHE_DURATION_MS = 1000 * 60 * 5;


export const BMG_COMPANY_ID = 3;

export const NOT_FOUND_PATH = '/not-found';
export const LOGIN_PATH = '/login';
export const COMPANY_LOGIN_PATH = '/login-company'
export const FORGOT_COMPANY_NAME_PATH = '/forgot-company-name';
export const DASHBOARD_PATH = '/dashboard';
export const CUSTOMERS_PATH = '/customers';
export const CASES_PATH = '/copilot';
export const INSERT_PATH = 'insert';

export const SEARCH_PATH = '/search';
export const SEARCH_CLIENT_PATH = 'client-search';
export const SEARCH_PHONE_PATH = 'phone-search';

export const FLAGS_DETAILS_PATH = '/flags/details';
export const FLAGS_FINISH_ANALYSIS_PATH = 'finish-analysis';

export const INVITE_PATH = 'invite-users';
export const CONFIG_PATH = '/config';

export const WATCHLISTS_DETAILS_PATH = '/watchlists/details';
export const CREATE_PROFILE = '/config/users/manage-profiles/create';
export const CREATE_TEMPLATE = '/config/manage-templates/create';

export const OPERATIONS_REPORT_PATH = '/reports/successful-operations';
